import React from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./BankCards.styles";
import { PaymentToken } from "../../pages/BankCardsPage/BankCardsTypes";
import PaymentCardTile from "./PaymentCardTile/PaymentCardTile";
import AddCardTile from "./AddCardTile/AddCardTile";
import Loader from "../common/loader/loader.component";

interface BankCardsProps {
  items: PaymentToken[];
  isLoading: boolean;
  removingId: string | null;
  onRemove: (id: string) => void;
  onAddCard: () => void;
  isAddingCard: boolean;
}

const BankCards: React.FC<BankCardsProps> = ({
  items,
  isLoading,
  removingId,
  onRemove,
  onAddCard,
  isAddingCard,
}) => {
  const { t } = useTranslation();
  const dir = t("css.side") as "rtl" | "ltr";
  const classes = useStyles();

  return (
    <div className={classes.container} dir={dir}>
      <div className={classes.headerRow}>
        <span className={`h2 ${classes.title}`}>{t("account.BankCards")}</span>
        <div className={classes.addCardLink}>
          <AddCardTile onClick={onAddCard} isLoading={isAddingCard} variant="link" />
        </div>
      </div>

      {isLoading ? (
        <div className={classes.tableLoader}>
          <Loader size={64} color="#B73232" />
        </div>
      ) : (
        <div className={classes.grid}>
          {items.map((paymentToken) => (
            <PaymentCardTile
              key={paymentToken.id}
              paymentToken={paymentToken}
              onRemove={() => onRemove(paymentToken.id)}
              isRemoving={removingId === paymentToken.id}
            />
          ))}
          <div className={classes.addCardTile}>
            <AddCardTile onClick={onAddCard} isLoading={isAddingCard} variant="tile" />
          </div>
        </div>
      )}
    </div>
  );
};

export default BankCards;
